import { useMutation } from 'react-query';

import { postV2ApiCompanyIdInternationalTransfersBusinessProfiles } from 'src/client/spendesk-api';

import { type PostV2ApiCompanyIdInternationalTransfersBusinessProfilesRequest } from '../../../../client/spendesk-api-types';

export function useCreateWiseBusinessProfile({
  companyId,
}: {
  companyId: string;
}) {
  return useMutation({
    mutationFn: async (
      businessRepresentative: PostV2ApiCompanyIdInternationalTransfersBusinessProfilesRequest['body']['businessRepresentative'],
    ) => {
      const response =
        await postV2ApiCompanyIdInternationalTransfersBusinessProfiles({
          path: {
            companyId,
          },
          body: {
            businessRepresentative,
          },
        });

      if (response.statusCode !== 200) {
        throw new Error('Error creating Wise business profile.');
      }

      return response.body.data;
    },
  });
}
